export default {
  siteName: "USFansSheet",
  navHome: "Inicio",
  navShoppingGuide: "Guía de compra",
  navSpreadsheet: "Hoja",
  navCategories: "Categorías",
  navGuides: "Guías",
  navFAQ: "FAQ",
  ctaExplore: "Explorar hoja",
  ctaBuyNow: "Comprar ahora",
  ctaMainSite: "Visitar sitio principal",
  dropdownLabel: "Explorar categorías",
  dropdownPlaceholder: "Elige una categoría…",
  footerTagline:
    "Un centro de recursos independiente para USFans Spreadsheet — te ayuda a descubrir hallazgos, comparar opciones y comprar de forma más inteligente.",
  footerQuickLinks: "Enlaces rápidos",
  footerCategories: "Categorías",
  footerLegal: "Legal",
  footerHome: "Inicio",
  footerGuide: "Guía de USFans Spreadsheet",
  footerAbout: "Acerca de",
  footerContact: "Contacto",
  footerPrivacy: "Política de privacidad",
  footerDisclaimer: "Aviso legal",
  footerAffiliate: "Divulgación de afiliados",
  externalNote: "Los enlaces externos se abren en una pestaña nueva.",
  copyright: "USFansSheet. Todos los derechos reservados.",
  notFoundTitle: "Página no encontrada",
  notFoundDesc: "La página que buscas no existe o ha sido movida. Vuelve al inicio para seguir explorando.",
  notFoundCta: "Volver al inicio",
  disclaimer:
    "USFansSheet es un recurso informativo independiente y no está afiliado con USFans, ni respaldado por él, ni es su sitio web oficial. Todos los enlaces de productos redirigen a sitios de terceros.",
  categories: {
    shoes: "Zapatos",
    hoodiesSweaters: "Sudaderas / Jerséis",
    tShirts: "Camisetas",
    jackets: "Chaquetas",
    pantsShorts: "Pantalones / Pantalones cortos",
    headwear: "Gorras / Sombreros",
    sets: "Conjuntos",
    underwear: "Ropa interior / Calzoncillos",
    jersey: "Camisetas deportivas",
    accessories: "Accesorios",
    bags: "Bolsos",
    belts: "Cinturones",
    perfumes: "Perfumes",
    otherStuff: "Otras cosas",
  },
};